import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { loadingChange, otpErrorChange, send_otp, setSignFlag } from '../../../redux/slices/AuthSlice';
import { URL } from '../../../config';
import { setSuccessMessage } from '../../../redux/slices/MessageSlice';

const OtpForm = () => {
    const dispatch = useDispatch();
    const {email,otpError}=useSelector((state)=>state.AuthReducer);
    const [otp,setOtp]=useState(Array(4).fill(""));
    const [disableButton,setDisableButton]=useState(true)
    const OtpHandel=(element,index)=>{   
        const  regex=/[0-9]$/;
       
        setOtp([...otp.map((data,idex)=>{

            if(index===idex){
                 dispatch(otpErrorChange(""));
                if(element.value){
                    if(!element.value.match(regex))
                   return data
                    if(element.nextSibling){
                        element.nextSibling.focus();
                        }

                    
                    }else{  
                        if(element.previousSibling){
                           element.previousSibling.focus();
                        }
                        
                    }   
            return element.value;     
            }
            return data;
        }
          )]);
        
    }
    const codeVerification=(e)=>{
        console.log(email);
    e.preventDefault();
    dispatch(loadingChange());
    axios.post(`${URL}/api/auth/otp_check`, {
        email: email,
        otp:otp.join("")
    }).then(function (response) {
      if(response.data.success){
        dispatch(setSignFlag(2));
          }
          else{
            dispatch(otpErrorChange("- كود غير صحيح"));
          }
          dispatch(loadingChange());
        })
    .catch(function (error) {
        dispatch(otpErrorChange("- خطأ اثناء الإرسال"));

      dispatch(loadingChange());
    });
    
    }
     const disableButtonF=()=>{
        otp.forEach(element => {
          if(!element){
            setDisableButton (true);
            return;
          }
          setDisableButton (false)
        })
      
       }
       const sendCode =()=>{
        
        dispatch(loadingChange());
        axios.post(`${URL}/api/auth/email_verification`, {
         email: email,
       }) .then(function (response) {
         if(response.data.success){
          dispatch(setSuccessMessage(' تم ارسال رمز التحقق'));
             }
             dispatch(loadingChange());
           })
       .catch(function (error) {
  
      dispatch(loadingChange());

       });
        
       } 
       useEffect(()=>{
        disableButtonF();
       },[otp])
  return (
    <form  onSubmit={codeVerification} style={{ justifyContent:'center',alignItems:'center' }}>
    <p className='code_paraph container'>رقم التحقق مطلوب لاكمال العملية لقد تم إرسال رمز التحقق فى رسالة إليكم</p>
    <p className='code_email'>{email}</p>
    <div className='otp'>
        {
            otp.map((data,index)=>(
                <input
                key={index}
                type='text'
                autocomplete="one-time-code"
                pattern="[0-9]*"
                id="email"
                maxlength="1" 
                name={otp} 
                value={data}
                onChange={(e)=>OtpHandel(e.target,index)}
                onFocus={e=>e.target.select()}
                
               />
            ))
         
        }
    </div>
    <p style={{ position:'absolute',color:'red',fontSize:'14px' }}>{otpError}</p>
    <input type='submit' disabled={disableButton} style={{ backgroundColor:disableButton&&"rgb(135 114 0 / 45%);",marginTop:'25px',marginBottom:'10px' }}  value="تحقيق"/>
    <p style={{color:'#b19d00',cursor:'pointer' ,textAlign:'center'}}
    onClick={sendCode}
    >اعادة الإرسال</p>
</form>
  )
}

export default OtpForm
